export default __webpack_public_path__ + "afea3c47ff43fb8b5a2b2627f0bbf070.svg";